import React from "react";
import { Loader2 } from "lucide-react";

const SkeletonLoader = ({ rows = 3 }) => {
  return (
    <div className="animate-pulse space-y-4">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 bg-gray-300 rounded-full" />
        <div className="h-4 w-32 bg-gray-300 rounded" />
      </div>

      {/* Dynamic Rows */}
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="space-y-2">
          <div className="h-4 bg-gray-300 rounded w-full" />
          <div className="h-4 bg-gray-300 rounded w-5/6" />
          <div className="h-4 bg-gray-300 rounded w-2/3" />
        </div>
      ))}

      {/* Loader Icon */}
      <div className="flex justify-center pt-4">
        <Loader2 className="animate-spin text-gray-400" size={24} />
      </div>
    </div>
  );
};

export default SkeletonLoader;